"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeVolt = exports.initializeVoltWithoutOptionMarketSeed = exports.sendInsList = exports.sendInsListCatching = exports.sendIns = exports.sendInsCatching = void 0;
var tslib_1 = require("tslib");
var web3_js_1 = require("@solana/web3.js");
var src_1 = require("../../src");
var sendTransactionHelpers_1 = require("./sendTransactionHelpers");
var TransactionMachine = /** @class */ (function () {
    function TransactionMachine(provider, params) {
        var _a, _b, _c, _d;
        this.provider = provider;
        this.timeout = params.timeout;
        this.setBlastAway((_a = params.blastAway) !== null && _a !== void 0 ? _a : false, (_b = params.blastInterval) !== null && _b !== void 0 ? _b : 500);
        this.commitmentLevel = (_c = params.commitmentLevel) !== null && _c !== void 0 ? _c : "processed";
        this.signers = (_d = params.signers) !== null && _d !== void 0 ? _d : [];
    }
    TransactionMachine.prototype.setBlastAway = function (shouldBlast, blastInterval) {
        if (shouldBlast) {
            this.blastAway = true;
            this.blastInterval = blastInterval;
            console.log("modifying timeout to very long period since blasting requires this");
            this.timeout;
        }
        else {
            this.blastAway = false;
            this.blastInterval = 0;
        }
    };
    TransactionMachine.prototype.blastTx = function (insList, signers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var txid, id;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        txid = undefined;
                        id = setInterval(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var thisTxid, err_1, i;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this.sendInsList(insList, signers)];
                                    case 1:
                                        thisTxid = _a.sent();
                                        txid = thisTxid;
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        i = 1;
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }, this.blastInterval);
                        _a.label = 1;
                    case 1:
                        if (!true) return [3 /*break*/, 3];
                        if (txid !== undefined) {
                            clearInterval(id);
                            return [2 /*return*/, txid];
                        }
                        return [4 /*yield*/, (0, sendTransactionHelpers_1.sleep)(500)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TransactionMachine.prototype.sendIns = function (ins, signers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.blastAway) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.blastTx([ins], signers)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, (0, exports.sendIns)(this.provider, ins, this.timeout)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TransactionMachine.prototype.sendInsCatching = function (ins) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, exports.sendInsCatching)(this.provider, ins, this.timeout)];
                    case 1: 
                    // if (this.blastAway)
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TransactionMachine.prototype.sendInsList = function (insList, signers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.blastAway) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.blastTx(insList, signers)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        signers = signers === null || signers === void 0 ? void 0 : signers.concat(this.signers);
                        return [4 /*yield*/, (0, exports.sendInsList)(this.provider, insList, signers, this.timeout)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TransactionMachine.prototype.sendInsListCatching = function (insList, signers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        signers = signers === null || signers === void 0 ? void 0 : signers.concat(this.signers);
                        return [4 /*yield*/, (0, exports.sendInsListCatching)(this.provider, insList, signers, this.timeout)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TransactionMachine.BLAST_TIMEOUT = 250;
    return TransactionMachine;
}());
var sendInsCatching = function (provider, ins, timeout) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var txid, err_2;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, (0, exports.sendIns)(provider, ins, timeout)];
            case 1:
                txid = _a.sent();
                return [2 /*return*/, {
                        success: true,
                        error: undefined,
                        txid: txid,
                    }];
            case 2:
                err_2 = _a.sent();
                console.log("error but fuck it");
                return [2 /*return*/, {
                        success: false,
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                        error: err_2.message,
                        txid: undefined,
                    }];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.sendInsCatching = sendInsCatching;
var sendIns = function (provider, ins, timeout) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var tx;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tx = new web3_js_1.Transaction();
                tx.add(ins);
                return [4 /*yield*/, (0, sendTransactionHelpers_1.makeAndSendTx)(provider.connection, provider.wallet.payer, tx, [], timeout)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.sendIns = sendIns;
var sendInsListCatching = function (provider, insList, signers, timeout) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var txid, err_3;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, (0, exports.sendInsList)(provider, insList, signers, timeout)];
            case 1:
                txid = _a.sent();
                return [2 /*return*/, {
                        success: true,
                        error: undefined,
                        txid: txid,
                    }];
            case 2:
                err_3 = _a.sent();
                return [2 /*return*/, {
                        success: false,
                        error: err_3,
                        txid: undefined,
                    }];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.sendInsListCatching = sendInsListCatching;
var sendInsList = function (provider, insList, signers, timeout) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var tx, _i, insList_1, ix;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tx = new web3_js_1.Transaction();
                for (_i = 0, insList_1 = insList; _i < insList_1.length; _i++) {
                    ix = insList_1[_i];
                    tx.add(ix);
                }
                return [4 /*yield*/, (0, sendTransactionHelpers_1.makeAndSendTx)(provider.connection, provider.wallet.payer, tx, signers !== null && signers !== void 0 ? signers : [], timeout)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.sendInsList = sendInsList;
var initializeVoltWithoutOptionMarketSeed = function (provider, friktionSdk, quoteAssetMint, underlyingAssetMint, permissionedMarketPremiumMint, underlyingAmountPerContract, 
// whitelistMintKey: PublicKey,
vaultType, transferTimeWindow, expirationInterval, upperBoundOtmStrikeFactor, seed, capacity, individualCapacity, permissionlessAuctions) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var _a, instruction, voltKey;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, src_1.VoltSDK.initializeVoltWithoutOptionMarketSeed({
                    sdk: friktionSdk,
                    user: provider.wallet.publicKey,
                    quoteAssetMint: quoteAssetMint,
                    underlyingAssetMint: underlyingAssetMint,
                    permissionedMarketPremiumMint: permissionedMarketPremiumMint,
                    underlyingAmountPerContract: underlyingAmountPerContract,
                    serumProgramId: friktionSdk.net.SERUM_DEX_PROGRAM_ID,
                    transferTimeWindow: transferTimeWindow,
                    expirationInterval: expirationInterval,
                    upperBoundOtmStrikeFactor: upperBoundOtmStrikeFactor,
                    seed: seed,
                    capacity: capacity,
                    individualCapacity: individualCapacity,
                    permissionlessAuctions: permissionlessAuctions,
                })];
            case 1:
                _a = _b.sent(), instruction = _a.instruction, voltKey = _a.voltKey;
                return [4 /*yield*/, (0, exports.sendIns)(provider, instruction)];
            case 2:
                _b.sent();
                return [2 /*return*/, voltKey];
        }
    });
}); };
exports.initializeVoltWithoutOptionMarketSeed = initializeVoltWithoutOptionMarketSeed;
var initializeVolt = function (provider, friktionSdk, optionMarket, permissionedMarketPremiumMint, vaultType, transferTimeWindow, expirationInterval, upperBoundOtmStrikeFactor, seed, capacity, individualCapacity, permissionlessAuctions) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var _a, instruction, voltKey;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, src_1.VoltSDK.initializeVolt({
                    sdk: friktionSdk,
                    user: provider.wallet.publicKey,
                    optionMarket: optionMarket,
                    permissionedMarketPremiumMint: permissionedMarketPremiumMint,
                    serumProgramId: friktionSdk.net.SERUM_DEX_PROGRAM_ID,
                    transferTimeWindow: transferTimeWindow,
                    expirationInterval: expirationInterval,
                    upperBoundOtmStrikeFactor: upperBoundOtmStrikeFactor,
                    seed: seed,
                    capacity: capacity,
                    individualCapacity: individualCapacity,
                    permissionlessAuctions: permissionlessAuctions,
                })];
            case 1:
                _a = _b.sent(), instruction = _a.instruction, voltKey = _a.voltKey;
                return [4 /*yield*/, (0, exports.sendIns)(provider, instruction)];
            case 2:
                _b.sent();
                return [2 /*return*/, voltKey];
        }
    });
}); };
exports.initializeVolt = initializeVolt;
